import log from './utils/logger.js'

import {enhanceJSLogic} from './utils/utils.js'
import {init as initTracking} from './tracking.js'
import {init as initGameController} from './games/game-controller.js'

export const init = (cxf) => {
    log.info('start initializing...')
    enhanceJSLogic()
    initTracking(cxf)
    initGameController(cxf)
}

init(window.CXF)
